<template>
	<div>
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<div class="trademarkList">
			<!-- 顶部选择器卡片 -->
			<!-- 已选列表 -->
			<div class="isSelect">
				<span>已选分类：</span>
				<span class="isSelectIndex" v-show="selectType" style="padding: 5px;">{{selectType}}</span>
			</div>
			<!-- 45类商标分类 -->
			<div class="tradeType">
				<div style="padding-left: 10px;">
					<p style="width:80px;">商标分类：</p>
				</div>
				<div :class="{'text-danger':isSelectIndex === 0}" class="allFont" @mouseout="isSelectIndex = -1">
					<p style="width:50px;" @mousemove="selectAllHover(item,index)" @click="selectAll">全部</p>
				</div>
				<div class="d-flex flex-wrap ml-2">
					<div v-for="(item,index) in tradeTypeList" :key="index" class="pr-3 pb-3"
						@mousemove="selectMove(item,index)" @click="tradeSelected(item,index)"
						@mouseout="isSelectIndex = -1">
						<span :class="{'isSelectIndex':item.id === isSelectIndex}" style="padding: 5px;"><span
								v-show="item.id<10">0</span>{{item.id}}类-{{item.name}}
						</span>
					</div>
				</div>
			</div>
			<!-- 商品列表 -->
			<div style="display: flex;flex-wrap: wrap;width: 1200px;">
				<el-skeleton style="width: 220px;margin-top:20px;" animated :rows="5" v-show="loading">
					<template #template>
						<el-skeleton-item variant="image" style="width: 220px; height:130px" />
						<div style="padding:5px">
							<el-skeleton-item variant="p"/>
							<div style="
				            display: flex;
				            align-items: center;
				            justify-items: space-between;
				          ">
								<el-skeleton-item variant="text" style="margin-right: 16px" />
							</div>
							<el-skeleton-item variant="text" style="width: 30%;"  class="mt-1"/>
							<el-skeleton-item variant="p" class="mt-4"/>
						</div>
					</template>
				</el-skeleton>
				<div v-for="(item,index) in hotPatent" class="mt-4 goodsHover" :key="index" v-show="!loading" style="margin-right: 20px;">
					<show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :price="'￥'+item.chargeAmount"
					:patentType="item.type"	@click="goodsShow(item.id,'商标交易','/trademarkList')"></show-card>
				</div>
				<div v-show="!loading && hotPatent.length <= 0" style="width: 300px;margin: 10px auto;">
					<el-empty description="暂无数据哦~"></el-empty>
				</div>
			</div>
			<!-- 分页器 -->
			<div style="text-align: center;" class="pt-4">
				<!-- 分页 -->
				<el-pagination background layout="prev, pager, next"
				@current-change="getHotBrand" :current-page="paging.currPage"
				:page-size="paging.everySize" :total="paging.allNum">
				</el-pagination>
			</div>
		</div>
		<!-- 底部导航 -->
		<div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import showCard from '@/components/showCard/showCard.vue'
	import Footer from '@/components/footer/footer.vue'
	export default {
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			showCard,
			Footer
		},
		data() {
			return {
				tradeTypeList: [{
						name: '化学原料',
						id: 1
					},
					{
						name: '颜料油漆',
						id: 2
					},
					{
						name: '化妆用品',
						id: 3
					},
					{
						name: '燃料油脂',
						id: 4
					},
					{
						name: '医用药品',
						id: 5
					},
					{
						name: '金属材料',
						id: 6
					},
					{
						name: '机械设备',
						id: 7
					},
					{
						name: '手工器械',
						id: 8
					},
					{
						name: '科学仪器',
						id: 9
					},
					{
						name: '医疗器械',
						id: 10
					},
					{
						name: '家用电器',
						id: 11
					},
					{
						name: '运输工具',
						id: 12
					},
					{
						name: '军火烟火',
						id: 13
					},
					{
						name: '珠宝钟表',
						id: 14
					},
					{
						name: '音乐器材',
						id: 15
					},
					{
						name: '办公文具',
						id: 16
					},
					{
						name: '橡胶制品',
						id: 17
					},
					{
						name: '皮革皮具',
						id: 18
					},
					{
						name: '建筑材料',
						id: 19
					},
					{
						name: '家具用品',
						id: 20
					},
					{
						name: '厨房洁具',
						id: 21
					},
					{
						name: '绳网袋篷',
						id: 22
					},
					{
						name: '纺织纱线',
						id: 23
					},
					{
						name: '布料床单',
						id: 24
					},
					{
						name: '服装鞋帽',
						id: 25
					},
					{
						name: '花边配饰',
						id: 26
					},
					{
						name: '地毯席垫',
						id: 27
					},
					{
						name: '健身娱乐',
						id: 28
					},
					{
						name: '肉食蜜饯',
						id: 29
					},
					{
						name: '方便食品',
						id: 30
					},
					{
						name: '饲料花木',
						id: 31
					},
					{
						name: '啤酒饮料',
						id: 32
					},
					{
						name: '酒精饮料',
						id: 33
					},
					{
						name: '烟草烟具',
						id: 34
					},
					{
						name: '广告销售',
						id: 35
					},
					{
						name: '金融物管',
						id: 36
					},
					{
						name: '建筑修理',
						id: 37
					},
					{
						name: '通讯服务',
						id: 38
					},
					{
						name: '运输贮藏',
						id: 39
					},
					{
						name: '材料加工',
						id: 40
					},
					{
						name: '教育娱乐',
						id: 41
					},
					{
						name: '技术服务',
						id: 42
					},
					{
						name: '餐饮住宿',
						id: 43
					},
					{
						name: '医疗园艺',
						id: 44
					},
					{
						name: '社会服务',
						id: 45
					},
				],
				hotPatent: [],
				// 鼠标滑过时的index
				isSelectIndex: 0,
				// 鼠标点击后选中的index
				clickSelectIndex: 0,
				selectType: '全部',
				// 骨架屏显示
				loading:false,
				paging: {currPage: 1, everySize: 20, allNum: 0},
				//检索条件
				condition: {
					type:''
				}
			}
		},
		mounted() {
			this.selectType = this.$route.params.selectType || '全部'
			// 获取商标数据
			this.getHotBrand()
		},
		methods: {
			// 获取商标数据
			getHotBrand(currentPage) {
				let vm = this
				vm.loading = true
				if(currentPage){
				   vm.paging.currPage = currentPage;
				} else {
				   vm.paging.currPage = 1;
				} 
				vm.axios.get('/api/brand/findAllByPage', {params:{
					type:vm.selectType == '全部' ? '' : vm.selectType,
					currPage: vm.paging.currPage,
					everySize: vm.paging.everySize
				}}).then(res => {
					vm.hotPatent = res.data.data.brands
					vm.paging = res.data.data.pagingBean
					vm.loading = false
				})
			},
			// 鼠标滑过分类列表
			selectMove(item, index) {
				let vm = this
				vm.isSelectIndex = item.id
			},
			// 滑过全部
			selectAllHover() {
				let vm = this
				vm.isSelectIndex = 0
			},
			// 选中全部
			selectAll() {
				let vm = this
				vm.selectType = '全部'
				this.getHotBrand()
			},
			// 鼠标点击选中
			tradeSelected(item, index) {
				let vm = this
				vm.selectType = item.id < 10 ? '0' + item.id + '类-' + item.name : item.id + '类-' + item.name
				vm.clickSelectIndex = item.id
				this.getHotBrand()
			},
			// 进入商品详情页
			goodsShow(id,mbx,mbxLink){
				let routeData = this.$router.resolve({
					path:'/goodsInfo',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:'brand'
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
	/* 商标列表 */
	.trademarkList {
		width: 1200px;
		min-height: 600px;
		margin: 0 auto;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	/* 已选列表 */
	.isSelect {
		width: 1200px;
		height: 50px;
		line-height: 50px;
		border: 1px solid var(--el-border-color-base);
		padding-left: 10px;
	}

	/* 鼠标滑过选中样式 */
	.isSelectIndex {
		background-color: orange;
		color: #fff;
		border-radius: 18px;
		cursor: pointer;
	}

	.allFont:hover {
		cursor: pointer;
		height: 20px;
	}

	/* 45类商标分类 */
	.tradeType {
		width: 1200px;
		border: 1px solid var(--el-border-color-base);
		margin-top: 10px;
		display: flex;
		color: #666;
		justify-content: space-between;
		padding-top: 20px;
		padding-bottom: 20px;
	}
	 .goodsHover{
		cursor: pointer; 
	 }
</style>
<style>
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #C32A1A;
	}
</style>
